var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{attrs:{"hide-mobile-menu-bar":true}},[_c('SearchBar',{class:_vm.$style.mobileSearchBar}),_c('BaseContent',{class:_vm.$style.searchArea},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }